export const InvalidException = (message: string) => {
  const error = Error(`${message}`);
  error.name = "AssertionException";
  return error;
};
